/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Q21Inputs */

const en__field_enum_q21 = /** @type {(inputs: _Field_Enum_Q21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q2`)
};

const de__field_enum_q21 = /** @type {(inputs: _Field_Enum_Q21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q2`)
};

/**
* | output |
* | --- |
* | "Q2" |
*
* @param {_Field_Enum_Q21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_q21 = /** @type {((inputs?: _Field_Enum_Q21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Q21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_q21(inputs)
	return de__field_enum_q21(inputs)
});
export { _field_enum_q21 as "_field_enum_Q2" }